<template>
  <div
    ref="containerRef"
    :class="['dropdown-container', isStatic ? 'static' : '']"
    :style="[containerStyle, !showShadow ? { boxShadow: 'none' } : {}]"
  >
    <div class="selected">
      <img v-if="showIcon" alt src="@/assets/form/filter.svg" />
      <span>{{ value.label }}</span>
      <template v-if="!isStatic">
        <font-awesome-icon
          v-if="!isOpen"
          class="text-warning"
          icon="fa-solid fa-sort-down"
        />
        <font-awesome-icon
          v-else
          class="text-warning"
          :style="{ top: 2 }"
          icon="fa-solid fa-sort-up"
        />
      </template>
    </div>
    <div
      v-show="isOpen && (options.length > 1 || showSearch)"
      class="dropdown-content"
      :style="[contentStyle, !showShadow ? { boxShadow: 'none' } : {}]"
    >
      <div class="d-flex flex-column">
        <input
          v-if="showSearch"
          type="text"
          class="form-control rounded-0 border-end-0 border-start-0 position-sticky top-0"
          style="outline: none; box-shadow: none"
          :value="search"
          @input="handleSearch"
        />
        <template v-for="item in options" :key="item.value || item.key">
          <div
            class="item"
            :style="[!showIcon ? { paddingLeft: '16px' } : {}, itemStyle]"
            v-if="(item.value || item.key) !== (value.value || value.key)"
            @click="handleOnChange(item)"
          >
            {{ item.label }}
          </div>
        </template>
        <div
          v-if="!options.length"
          class="text-center"
          style="padding: 4px 16px"
        >
          No Data
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showIcon: {
      type: Boolean,
      default: true,
    },
    showShadow: {
      type: Boolean,
      default: true,
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    isStatic: Boolean,
    containerStyle: Object,
    contentStyle: Object,
    itemStyle: Object,
    options: Array,
    value: Object,
  },
  data() {
    return {
      isOpen: false,
      search: "",
    };
  },
  methods: {
    handleClick(event) {
      let currentRef = this.$refs.containerRef;
      if (currentRef.contains(event.target)) {
        if (!this.isOpen) {
          this.isOpen = true;
        } else if (
          this.isOpen &&
          currentRef.children[0].contains(event.target)
        ) {
          this.isOpen = false;
        }
      } else if (!currentRef.contains(event.target)) {
        this.isOpen = false;
      }
    },
    handleOnChange(value) {
      this.$emit("onChange", value);
      this.isOpen = false;
    },
    handleSearch(e) {
      const { value } = e.target;
      this.search = value;
      this.$emit("onSearch", value);
    },
  },
  mounted() {
    if (this.isStatic) return;
    document.addEventListener("mousedown", this.handleClick, {
      passive: true,
    });
  },
  unmounted() {
    if (this.isStatic) return;
    document.removeEventListener("mousedown", this.handleClick);
  },
};
</script>

<style lang="scss" scoped>
.dropdown-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border: thin solid #fdd1d4;
  border-radius: 8px;
  padding: 0 16px;
  width: 100%;
  height: 40px;
  font-weight: 700;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.08);
  user-select: none;
  cursor: pointer;
  &.static {
    cursor: default;
  }

  .selected {
    display: flex;
    align-items: center;
    width: 100%;

    img {
      margin-right: 8px;
    }

    span {
      margin-right: 8px;
    }

    svg {
      bottom: 2px;
      position: relative;
      margin-left: auto;
    }
  }

  .dropdown-content {
    position: absolute;
    display: flex;
    flex-direction: column;
    width: calc(100% + 2px);
    background-color: #ffffff;
    padding-bottom: 4px;
    top: 32px;
    left: -1px;
    z-index: 2;
    border: thin solid #fdd1d4;
    border-top: none;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 10px 8px 0 rgba(0, 0, 0, 0.08);
    overflow-y: auto;
    max-height: 250px;

    .item {
      padding: 4px 16px;
      padding-left: 48px;
      &:hover {
        background-color: #f3f2f8;
      }
    }
  }
}
</style>
